import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { AvailabilitySchema } from "../../Availability";
import { BackdropSchema } from "../../Backdrop";
import { ContentItemSchema } from "../../ContentItem";
import { LinkItemSchema } from "../../LinkItem";
import { LogoSchema } from "../../Logo";
import { BladeHeaderSchema } from "../../BladeHeader";
import { RichTextSchema } from "../../RichText";
export const ProductMastheadBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    logo: LogoSchema.optional(),
    tagline: z.string().optional(),
    links: z.array(LinkItemSchema).optional(),
    availability: AvailabilitySchema.optional(),
    contentList: z.array(ContentItemSchema).optional(),
    linksLabel: RichTextSchema.optional(),
});
//# sourceMappingURL=index.js.map